const ua = navigator.userAgent
// 是否 wps 客户端
// @ts-ignore
export const isWPS = () => typeof window.cefQuery !== 'undefined' || typeof window.wpsQuery !== 'undefined'
// 是否移动端
export const isMobile = () => /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua)
// @ts-ignore
export const isWPSApp = typeof window.wps !== 'undefined'
// 是否为mac系统
export const isMac = /macintosh/i.test(ua)
export const isIOS = /iPhone/i.test(ua)
// 是否WPS MAC客户端
export const isMacWPS = isWPS() && isMac
// 是否金山文档客户端
export const isKdocsClient = /kdesktop/i.test(ua)
// 是否金山文档
export const isKdocs = (/kdocs\.cn/.test(location.hostname) || /drive\.wps\.cn/.test(location.hostname))
// 是否管理后台
export const isworkAdmin = /work\.wps\.cn/.test(location.hostname)
// 是否PC内嵌
export const isDocsPC = /plus\.wps\.cn\/pc\/ent/.test(location.href)
// 是否金山文档移动端app
export const isKdocsApp = /m-kdocs\/[0-9.]*/.test(ua)
// 是否微信浏览器
export const isWx = /MicroMessenger/i.test(ua)
// 是否微信小程序
export const isWxMp = isWx && /miniProgram/i.test(ua)
// 是否qq小程序
export const isQQMp = /QQ.+miniprogram/i.test(ua)
// 是否wps365本地页
export const isWPS365Local = (function () {
  // 打进客户端包的本地页是没有cookie的，所以判断时候本地页要用路径判断
  return document.location.href.includes('file://')
})()
// 是否365在线页
export const isWPS365Online = (function () {
  return !!document.cookie.match('wpsoffice_hyperion')
})()
// 是否wps365
export const isWPS365 = (function () {
  return (isWPS365Local || isWPS365Online)
})()

/**
 * 解析 url 的查询参数
 * @param url 查询字符串
 * @returns
 */
export const parseQuery = (url: string) => {
  const param: any = {}
  if (!url) {
    return param
  }

  const p = url.split('?').filter((x) => x)
  if (url.includes('://') && p.length === 1) {
    return param
  }
  const search = p.pop()
  if (!search) {
    return param
  }

  const parts = search.split('&')
  parts.forEach((part) => {
    if (!part) {
      return
    }
    const kv = part.split('=')
    let key = kv[0]
    // 特殊处理 企业ID参数，将 companyId companyID companyid 换成 comp_id
    if (key.toLowerCase() === 'companyid') {
      key = 'comp_id'
    }
    param[key] = kv.length === 1 ? '' : kv[1]
  })
  return param
}

// 设备端来源
export const getUtmSource = () => {

  const pageQuery = parseQuery(location.href)
  const source = pageQuery.utm_source || pageQuery.source
  if (source) {
    return source
  }
  if (isWPS365) {
    return 'WPS365_PC'
  }

  // 管理后台
  if (isworkAdmin) {
    if (isWPS()) {
      // wps office 客户端
      return isMac ? 'macofficework' : 'pcofficework'
    }
    if (isKdocsClient) {
      // 金山文档客户端
      return isMac ? 'docsMacwork' : 'docsPcwork'
    }
    return isMobile() ? 'workh5' : 'work'
  }

  // 内嵌
  if (isDocsPC) {
    return isMac ? 'macoffice' : 'pcoffice'
  }

  // 金山文档
  if (isKdocs) {
    if (isWPS365) {
      return 'pcoffice'
    }
    if (isWPS() || isKdocsClient) {
      return isMac ? 'docsMac' : 'docsPc'
    }
    if (isKdocsApp) {
      return isIOS ? 'docsIos' : 'docsAn'
    }
    return 'docsWeb'
  }
  if (isWxMp) {
    return 'wxminiprogram'
  }
  if (isQQMp) {
    return 'qqminiprogram'
  }
  if (isWPSApp) {
    return isIOS ? 'iOSoffice' : 'anoffice'
  }
  return isWx ? 'wechat5' : 'docsWeb'
}
export const utmSource = getUtmSource()
